import * as megatronNativeTile from '../../action_creators/homepage/megatron_native_tile_action_creators';
import MegatronNativeTileModel from '../../../models/homepage/homepage_megatron_native_tile_module';
import log from '../../../services/logger_service';

export default function fetchMegatronModule(params, store) {
  return function firstDispatchMegatron(dispatch) {
    dispatch(megatronNativeTile.megatronNativeTileLoading());

    // const state = store.getState();

    return MegatronNativeTileModel.fetch(params, store)
      .then(function handleMegatronModuleData(resp) {
        const { data } = resp;
        dispatch(megatronNativeTile.megatronNativeTileLoaded(data, store));
      })
      .catch(function handleMegatronError(err) {
        dispatch(megatronNativeTile.megatronNativeTileLoadError(err, store));
        log.error(
          err,
          `Error in homepage megatronNativeTile actions, message: ${
            err.message
          }`
        );
      });
  };
}
